import { Pipe, PipeTransform } from "@angular/core";

import { Facility } from "../model/facility";

@Pipe({
    name: 'filterFavorites'
})
export class FilterFavoritesPipe implements PipeTransform {

    transform(value: Array<Facility>, filterValue: boolean) {
        if (filterValue === true) {
            const filtered = [];
            value.forEach(x => {
                let tempPl = x.ProductLinesCache.filter(a => { return a.Favorite === true });
                if (tempPl.length > 0) {
                    x.ProductLines = tempPl;
                    filtered.push(x);
                }
            });
            if(filtered.length === 0) { return [{ empty: true, message: 'No Matches Found.' }] }
            return filtered;
        } else {
            if (value !== undefined && value !== null) {
                value.forEach(x => { x.ProductLines = x.ProductLinesCache; });
            }
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/filter-favorites.pipe.ts